import Vue from "vue";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ClassicEditor from 'ckeditor5-build-classic-plus';

//import { AutoLink, Link } from '@ckeditor/ckeditor5-link';
//import ClassicEditor from 'ckeditor5-custom-build/build/ckeditor';
//import { GeneralHtmlSupport } from '@ckeditor/ckeditor5-html-support';
Vue.component("wto-ck-editor", {
    props: ["viewModelData"],
    computed: {
        computedValue: {
            get() {
                return !this.viewModelData ? "" : this.viewModelData;
            },
            set(value) {
                console.log(value)
                this.$emit("update:viewModelData", value);
            }
        },
        editorConfig() {
            let returnValue = {
                //plugins: [AutoLink, Link],
                toolbar: {
                    items: [
                        'heading', 'fontsize', '|',
                        'alignment', '|',
                        'fontColor', 'fontBackgroundColor', '|',
                        'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
                        'link', '|',
                        'outdent', 'indent', '|',
                        'bulletedList', 'numberedList', '|',
                        'insertTable', '|',
                        'undo', 'redo'
                    ],
                    shouldNotGroupWhenFull: true
                },
                table: {
                    contentToolbar: [
                        'tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties', 'tableResize'
                    ],
                },
                height: 500,
                allowedContent: true,
                removeFormatAttributes: '',
                htmlSupport: {
                    allow: [
                        {
                            name: /.*/,
                            attributes: true,
                            classes: true,
                            styles: true
                        }
                    ]
                }
            };

            return returnValue;
        },
    },
    data() {
        return {
            editor: ClassicEditor
        };
    },
    template: `      
	   <ckeditor tag-name="textarea" :editor="editor" v-model="computedValue" :config="editorConfig"></ckeditor>       
	`
});